var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "editar 1",
    clipPath: "url(#clip0_1809_61792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.4361 88.4249C42.65 88.4249 55.8445 98.3777 65.1028 98.3777C74.3611 98.3777 93.8056 93.0555 93.8056 50.4638C93.8056 7.87216 67.6473 1.61938 57.4639 1.61938C9.77781 1.61938 -10.5916 88.4249 23.4361 88.4249Z",
    fill: "#FBE2E8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M56.4167 27.0834H50.8611V29.8612C50.8611 31.3945 49.6167 32.6389 48.0834 32.6389H32.8056C31.2722 32.6389 30.0278 31.3945 30.0278 29.8612V27.0834H24.4722C21.4167 27.0834 18.9167 29.5834 18.9167 32.6389V67.3611C18.9167 70.4167 21.4167 72.9167 24.4722 72.9167H56.4167C59.4722 72.9167 61.9722 70.4167 61.9722 67.3611V32.6389C61.9722 29.5834 59.4722 27.0834 56.4167 27.0834Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M50.8611 24.3056V29.8611C50.8611 31.3944 49.6167 32.6389 48.0834 32.6389H32.8056C31.2722 32.6389 30.0278 31.3944 30.0278 29.8611V24.3056H34.8889C34.8889 21.25 37.3889 18.75 40.4445 18.75C43.5 18.75 46 21.25 46 24.3056H50.8611Z",
    fill: "#D586B0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M59.9778 79.7778L51.6306 81.2501L53.1028 72.9028L73.7278 52.2778C74.8139 51.1917 76.0806 50.7028 77.1639 51.7862L80.6 55.2223C81.6861 56.3084 81.6861 58.0667 80.6 59.1501L59.9778 79.7778Z",
    fill: "#D586B0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M57.1111 29.8612V27.1528C56.8806 27.1223 56.6556 27.0834 56.4167 27.0834H50.8611V29.8612C50.8611 31.3945 49.6167 32.6389 48.0833 32.6389H54.3333C55.8667 32.6389 57.1111 31.3945 57.1111 29.8612Z",
    fill: "#FBE2E8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M25.1667 67.3611V32.6389C25.1667 29.8223 27.3 27.5028 30.0278 27.1528V27.0834H24.4722C21.4167 27.0834 18.9167 29.5834 18.9167 32.6389V67.3611C18.9167 70.4167 21.4167 72.9167 24.4722 72.9167H30.7222C27.6667 72.9167 25.1667 70.4167 25.1667 67.3611Z",
    fill: "#FBE2E8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M36.2778 29.8611V24.3056H41.1389C41.1389 22.4083 42.1056 20.725 43.5695 19.7222C42.6778 19.1111 41.6028 18.75 40.4445 18.75C37.3889 18.75 34.8889 21.25 34.8889 24.3056H30.0278V29.8611C30.0278 31.3944 31.2722 32.6389 32.8056 32.6389H39.0556C37.5222 32.6389 36.2778 31.3944 36.2778 29.8611Z",
    fill: "#9F4487"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M59.3556 72.9028L78.8195 53.4389L77.1667 51.7862C76.0806 50.7 74.8139 51.1917 73.7306 52.2778L53.1056 72.9028L51.6334 81.25L58.0834 80.1112L59.3556 72.9028Z",
    fill: "#9F4487"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M51.6306 83.3334C51.0834 83.3334 50.55 83.1167 50.1584 82.7223C49.6778 82.2417 49.4611 81.5556 49.5806 80.889L51.0528 72.5417C51.125 72.1195 51.3306 71.7306 51.6306 71.4306L72.2556 50.8056C74.7917 48.2695 77.2778 48.9501 78.6389 50.314L82.075 53.7501C83.9723 55.6473 83.9723 58.7278 82.075 60.6251L61.45 81.2501C61.15 81.5501 60.7612 81.7556 60.3389 81.8278L51.9917 83.3001C51.8723 83.3223 51.75 83.3334 51.6306 83.3334ZM55.0417 73.9112L54.2 78.6806L58.9695 77.8389L79.1306 57.6778C79.4028 57.4056 79.4028 56.9667 79.1306 56.6945L75.7195 53.2834C75.6917 53.3362 75.4806 53.4667 75.2 53.7473L55.0417 73.9112Z",
    fill: "#571259"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M44.6389 75H24.4722C20.2583 75 16.8333 71.575 16.8333 67.3611V32.6389C16.8333 28.425 20.2583 25 24.4722 25H29.6945V29.1667H24.4722C22.5583 29.1667 21 30.725 21 32.6389V67.3611C21 69.275 22.5583 70.8333 24.4722 70.8333H44.6389V75Z",
    fill: "#571259"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M64.0556 52.25H59.8889V32.6389C59.8889 30.725 58.3306 29.1667 56.4167 29.1667H51.2222V25H56.4167C60.6306 25 64.0556 28.425 64.0556 32.6389V52.25Z",
    fill: "#571259"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M48.0833 34.7222H32.8056C30.125 34.7222 27.9445 32.5416 27.9445 29.8611V24.3055C27.9445 23.1555 28.8778 22.2222 30.0278 22.2222H33.0945C34.0056 19.0194 36.9556 16.6666 40.4445 16.6666C43.9333 16.6666 46.8833 19.0194 47.7945 22.2222H50.8611C52.0111 22.2222 52.9445 23.1555 52.9445 24.3055V29.8611C52.9445 32.5416 50.7639 34.7222 48.0833 34.7222ZM32.1111 26.3888V29.8611C32.1111 30.2444 32.4222 30.5555 32.8056 30.5555H48.0833C48.4667 30.5555 48.7778 30.2444 48.7778 29.8611V26.3888H46C44.85 26.3888 43.9167 25.4555 43.9167 24.3055C43.9167 22.3916 42.3583 20.8333 40.4445 20.8333C38.5306 20.8333 36.9722 22.3916 36.9722 24.3055C36.9722 25.4555 36.0389 26.3888 34.8889 26.3888H32.1111Z",
    fill: "#571259"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M27.25 38.8889H53.6389V43.0556H27.25V38.8889Z",
    fill: "#571259"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M27.25 47.2222H53.6389V51.3888H27.25V47.2222Z",
    fill: "#571259"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M27.25 55.5555H53.6389V59.7222H27.25V55.5555Z",
    fill: "#571259"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M78.8167 41.0555C76.5195 41.0555 74.65 39.1861 74.65 36.8888C74.65 34.5916 76.5195 32.7222 78.8167 32.7222C81.1139 32.7222 82.9833 34.5916 82.9833 36.8888C82.9833 39.1861 81.1167 41.0555 78.8167 41.0555ZM78.8167 35.4999C78.0528 35.4999 77.4278 36.1249 77.4278 36.8888C77.4278 37.6527 78.0528 38.2777 78.8167 38.2777C79.5806 38.2777 80.2056 37.6527 80.2056 36.8888C80.2056 36.1249 79.5833 35.4999 78.8167 35.4999Z",
    fill: "#D586B0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M45.6528 9.02783H51.2084V11.8056H45.6528V9.02783Z",
    fill: "#D586B0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M29.6806 9.02783H35.2361V11.8056H29.6806V9.02783Z",
    fill: "#D586B0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M39.4028 0H42.1806V5.55556H39.4028V0Z",
    fill: "#D586B0"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1809_61792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.166687)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.010f78a088f3cc2c461bda1cfd163d69.svg";
export { ForwardRef as ReactComponent };